import React from 'react'
import { X } from 'lucide-react'
import { cn } from '../../utils/cn'

interface ModalProps {
 isOpen: boolean
 onClose: () => void
 title?: string
 description?: string
 children: React.ReactNode
 size?: 'sm' | 'md' | 'lg' | 'xl'
}

export const Modal: React.FC<ModalProps> = ({
 isOpen,
 onClose,
 title,
 description,
 children,
 size = 'md'
}) => {
 if (!isOpen) return null

 const sizes = {
 sm: 'max-w-md',
 md: 'max-w-lg',
 lg: 'max-w-2xl',
 xl: 'max-w-4xl'
 }

 return (
 <div className="fixed inset-0 z-50 overflow-y-auto">
 <div className="flex min-h-screen items-center justify-center p-4 text-center sm:p-0">
 {/* Backdrop */}
 <div
 className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
 onClick={onClose}
 />
 
 {/* Modal */}
 <div
 className={cn(
 'relative transform overflow-hidden rounded-lg bg-card text-left shadow-xl transition-all sm:my-8 sm:w-full',
 sizes[size]
 )}
 >
 {/* Header */}
 {title && (
 <div className="flex items-center justify-between border-b border-border px-6 py-4">
 <div>
 <h3 className="text-lg font-semibold text-foreground">
 {title}
 </h3>
 {description && (
 <p className="mt-1 text-sm text-muted-foreground">{description}</p>
 )}
 </div>
 <button
 type="button"
 onClick={onClose}
 className="rounded-md p-1 text-muted-foreground hover:text-muted-foreground dark:hover:text-gray-300 focus:outline-none focus:ring-2 focus:ring-accent"
 >
 <X className="h-5 w-5" />
 </button>
 </div>
 )}
 
 {/* Content */}
 <div className="px-6 py-4">
 {children}
 </div>
 </div>
 </div>
 </div>
 )
}
